// TODO: fix Issue with eslint and ts config conflicts
// eslint-disable-next-line no-shadow
export enum RuntimeEnv {
    Prod = 'Prod',
    Stg = 'Stg',
    Dev = 'Dev',
    Local = 'Local'
}
